<template>
  <div :id="page.portfolio.$path" v-if="page.portfolio" :class="{'active': isActive()}">
    <div class="section">
      <div class="section__top" v-sticky="{ zIndex: 1, stickyTop: 0 }">
        <div>
          <div class="section__text reduced-width">
            <PageTitle :isActive="isActive()" :isAnimated="isAnimated" :class="{'static': isAnimated}" :titleValue="page.portfolio.title"></PageTitle>
            <Description :descrValue="page.portfolio.text_description" :isActive="isActive()" :class="{'static': isAnimated}"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PageTitle from '@/components/PageTitle';
import Description from '@/components/Description';

export default {
  name: 'portfolio',
  data() {
    return {
      isAnimated: false,
    };
  },
  components: {
    PageTitle,
    Description,
  },
  computed: mapGetters({
    lang: 'lang',
    page: 'page',
    currentPage: 'currentPage',
  }),
  methods: {
    isActive() {
      const checkActive = this.currentPage === this.page.portfolio.$path;
      const animationTime = (this.page.portfolio.title.length * 70) + 900;
      setTimeout(() => {
        if (checkActive) {
          this.isAnimated = true;
        }
      }, animationTime);
      return checkActive;
    },
  },
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  #portfolio {
    .section {
      position: relative;
      height: 200vh;
      margin-bottom: -100vh;
      &_top{
        position: relative !important;
      }
    }
  }

  @media (max-width: 850px) {
    .portfolio {
      margin: 0 -25px;
    }
  }
</style>




// WEBPACK FOOTER //
// src/pages/Portfolio.vue?4debcb76